export default {
  getAddADonation: (state) => {
    return state.addADonation;
  },
};

